import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('zh-cn');

export { dayjs }
export const KEY_GLOBAL_LOADING = 'global-loading-key';

export const REQUIRED_RULES = { required: true };